import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from "@angular/core";
import { CatalogBrandEx } from "@front/m19-models";
import { CatalogBrandService } from "@front/m19-services";
import { IButtonDirective, ISelectMenuImports, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: "app-brand-merge-modal",
  templateUrl: "./brand-merge-modal.component.html",
  imports: [TranslocoDirective, ISelectMenuImports, IButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandMergeModalComponent implements OnInit {
  private catalogBrandService = inject(CatalogBrandService);

  modalData = inject(MODAL_DATA) as BrandMergeModalData;
  modalRef = inject(ModalRef);

  protected readonly brands = signal<CatalogBrandEx[]>([]);
  protected readonly searchQuery = signal("");
  protected readonly brandSelected = signal<CatalogBrandEx | undefined>(undefined);

  protected readonly filteredBrands = computed(() => {
    const query = this.searchQuery().toLowerCase();
    return this.brands().filter((brand) => !query || (brand.brandAlias ?? "").toLowerCase().includes(query));
  });

  ngOnInit(): void {
    this.catalogBrandService
      .getCatalogBrands(this.modalData.catalogBrand.accountId!, this.modalData.catalogBrand.marketplace!)
      .pipe(untilDestroyed(this))
      .subscribe((brands) => {
        this.brands.set(
          brands.filter(
            (brand) =>
              brand.brandId !== this.modalData.catalogBrand.brandId &&
              (brand.parentBrandId == undefined || brand.parentBrandId === brand.brandId),
          ),
        );
      });
  }

  merge() {
    this.modalRef.close(this.brandSelected());
  }

  close() {
    this.modalRef.close();
  }
}

export interface BrandMergeModalData {
  catalogBrand: CatalogBrandEx;
}
